// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"31b64dca","239":"e685f566","732":"fe5cc127","977":"9ea38446"}[chunkId] + ".chunk.js";
};